import { same } from './same.esm.js';

var getLayoutByName = function getLayoutByName(layouts, name) {
  return layouts.find(function (l) {
    return same(l.label, name);
  });
};

export { getLayoutByName };
//# sourceMappingURL=get-layout-by-name.esm.js.map
